"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jimp_1 = __importDefault(require("jimp"));
var svg_engine_1 = require("./svg.engine");
function renderRTRImage(svg, layer, data, debug) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var url, imageNode, stepImage, shouldResizeImage, _d, preserveAspectRatio, png;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (debug)
                        console.log("[RTR] [image]: Processing layer: ", layer);
                    url = (_b = (_a = layer.image) === null || _a === void 0 ? void 0 : _a.url) !== null && _b !== void 0 ? _b : data[layer.tag];
                    if (!url) {
                        throw new Error("URL not found for: ".concat(layer.tag, "/").concat((_c = layer.image) === null || _c === void 0 ? void 0 : _c.url));
                    }
                    imageNode = svg_engine_1.SVGEngine.getNode("image", {
                        width: layer.width,
                        height: layer.height,
                        x: layer.positionX,
                        y: layer.positionY,
                    });
                    if (debug)
                        console.log("[RTR] [image]: Loading URL: ", url);
                    return [4 /*yield*/, jimp_1.default.read(url)];
                case 1:
                    stepImage = _e.sent();
                    shouldResizeImage = true;
                    if ((data === null || data === void 0 ? void 0 : data.layerOptions) && layer.tag && (data === null || data === void 0 ? void 0 : data.layerOptions[layer.tag])) {
                        _d = (data === null || data === void 0 ? void 0 : data.layerOptions[layer.tag]).preserveAspectRatio, preserveAspectRatio = _d === void 0 ? false : _d;
                        shouldResizeImage = !preserveAspectRatio;
                    }
                    if (shouldResizeImage) {
                        stepImage.resize(layer.width, layer.height);
                    }
                    if (debug)
                        console.log("[RTR] [image]: Generating base64 image...");
                    return [4 /*yield*/, stepImage.getBase64Async("image/png")];
                case 2:
                    png = _e.sent();
                    imageNode.setAttributeNS("http://www.w3.org/1999/xlink", "href", png);
                    svg.appendChild(imageNode);
                    if (debug)
                        console.log("[RTR] [image]: Done");
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = renderRTRImage;
